import React from "react"
import { Grid } from "@mui/material"
import { DrawerSeeker } from "@ui-seeker/core"

import { isEditUserSettingsTierDrawer, isOpenUserSettingsTierDrawer, userSettingsTierFormData } from "../../@signals"
import UserSettingTierDrawerName from "./Name"
import UserSettingTierDrawerProviders from "./Providers"
import UserSettingTierDrawerSubmit from "./Submit"


export default function UserSettingTierDrawer() {

	return <DrawerSeeker
		hideActions
		title={isEditUserSettingsTierDrawer.value ? 'Edit tier' : 'New Tier'}
		isOpen={isOpenUserSettingsTierDrawer.value}
		controller={() => userSettingsTierFormData.value = { }}
		successText="save"
	>
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<UserSettingTierDrawerName />
			</Grid>

			<Grid item xs={12}>
				<UserSettingTierDrawerProviders />
			</Grid>

			<Grid item xs={12} sx={{  display: 'flex', justifyContent: 'flex-end'  }}>
				<UserSettingTierDrawerSubmit />
			</Grid>
		</Grid>
	</DrawerSeeker>
}